export default [
  { key: "home", path: "" },
  {
    key: "operation",
    items: [
      { key: "cp_request", path: "cp_requests" },
      { key: "cp_session", path: "cp_sessions" },
      { key: "cp_sessions_all", path: "cp_sessions_all" },
      { key: "alert", path: "alert" },
      { key: "user_log", path: "user_log" },
      { key: "cp_rsr", path: "cp_rsr"},
      { key: "cp_rsr_request", path: "cp_rsr_request"},
      { key: "cp_rsr_api_log", path: "cp_rsr_api_log"},
      { key: "payment_result_detail", path: "payment_result_detail"},
      { key: "third_party_error_log", path:"third_party_error_log"},
      { key: "portal_action_log", path: "portal_action_log"},
    ]
  },
  {
    key: "management",
    items: [
      { key: "cp", path: "cps" },
      { key: "account", path: "accounts" },
      { key: "account_vehicle", path: "account_vehicles" },
      // { key: "service_plan", path: "service_plans" },
      { key: "account_service_plan", path: "account_service_plans" },
      { key: "cp_loc", path: "cp_locs" },
      { key: "cp_zone", path: "cp_zones" },
      { key: "cp_power_meter", path: "cp_pow" },
      { key: "auth_card", path: "auth_card" },
      { key: "opening_hour", path: "opening_hour" },
      { key: "contact", path: "contact" },
      { key: "contact_group", path: "contact_group" },
      { key: "charging_rate", path: "charging_rate"},
      { key: "bay", path: "bay"},
      { key: "bay_log", path: "bay_log"},
      { key: "voucher", path: "voucher"}
    ]
  },
  {
    key: "setting",
    items: [
      { key: "role", path: "roles" },
      { key: "privilege", path: "privileges", role_only: ["super_admin"] },
      { key: "role_n_permission", path: "rnp" },
      { key: "user", path: "users" },
      { key: "data_rotation_setup", path: "data_rotation_setup" },
      { key: "third_party_configuration", path: "third_party_conf" },
      { key: "app_config", path: "app_config" },
    ]
  },
  {
    key: "lms",
    items: [
      { key: "lms_dashboard", path: "lms/dashboard" },
      { key: "cp_request_test", path: "test/cp_request" },
      { key: "cp_simulator", path: "lms/cp_simulator" },
      { key: "lms_profile", path: "lms_profiles" },
      { key: "realtime_log", path: "realtime/log" }
    ]
  },
]